// src/components/Navbar.jsx
import { useState } from "react";

export default function Navbar() {
  const [open, setOpen] = useState(false);

  const links = [
    { href: "#home", label: "Home" },
    { href: "#services", label: "Services" },
    { href: "#doctors", label: "Doctors" },
    { href: "#products", label: "Products" },
    { href: "#gallery", label: "Gallery" },
  ];

  return (
    <header className="bg-white/90 backdrop-blur sticky top-0 z-50 border-b">
      <div className="mx-auto max-w-6xl px-6 py-4 flex items-center justify-between">
        <a href="#home" className="text-2xl font-semibold text-brandBlue">
          Furniture
        </a>

        {/* Desktop nav */}
        <nav className="hidden md:flex gap-8 text-gray-700">
          {links.map(l => (
            <a key={l.href} href={l.href} className="hover:text-brandBlue">
              {l.label}
            </a>
          ))}
        </nav>

        {/* Mobile toggle */}
        <button
          className="md:hidden p-2 rounded hover:bg-gray-100"
          aria-label="Open menu"
          aria-expanded={open}
          onClick={() => setOpen(v => !v)}
        >
          {/* Icon */}
          <svg width="24" height="24" fill="none" stroke="currentColor">
            <path strokeWidth="2" d="M4 7h16M4 12h16M4 17h16" />
          </svg>
        </button>
      </div>

      {/* Mobile menu */}
      {open && (
        <nav className="md:hidden border-t bg-white">
          <div className="mx-auto max-w-6xl px-6 py-3 flex flex-col gap-3">
            {links.map(l => (
              <a
                key={l.href}
                href={l.href}
                className="py-2 text-gray-700 hover:text-brandBlue"
                onClick={() => setOpen(false)}
              >
                {l.label}
              </a>
            ))}
          </div>
        </nav>
      )}
    </header>
  );
}

